<template>
    <div class="column right has-text-centered">
        <h1 class="title is-4">Login</h1>
        <p class="description">Ingresa tu correo y tu contraseña</p>
        <form @submit.prevent="submit">
            <div class="field">
                <div class="control">
                    <input class="input is-medium" type="email" placeholder="Email"
                        name="email" id="email" v-model="form.email">
                </div>
            </div>
            
            <div class="field">
                <div class="control">
                    <input class="input is-medium" type="password" placeholder="Contraseña"
                        name="password" id="password" v-model="form.password">
                </div>
            </div>

            <!-- <button class="button is-block is-primary is-fullwidth is-medium">Submit</button> -->
            <button type="submit" class="button is-block is-primary is-fullwidth is-medium">Ingresar</button>
            <br />
            <small class="has-text-danger"><em>{{errors}}</em></small>
        </form>
    </div>                    
</template>

<script>

import {mapGetters, mapActions} from 'vuex'

export default {
    name: 'signin',
    created(){
        this.clearAuthErrors()
    },
    components: {
        //
    },
    computed: {
        ...mapGetters({
            errors: 'auth/errors'
        }),
    },        
    data(){
        return{
            form:{
                email: '',
                password: ''
            }
        }
    },
    methods:{
        ...mapActions({
            signIn: 'auth/signIn',
            clearAuthErrors: 'auth/clearAuthErrors',
        }),

        submit(){
            this.signIn(this.form).then( () => {
                console.log("Login OK");
            }).catch(() => {
                console.log("Login Failed!");
            })
        }
    }
}
</script>


<style>

</style>